import { Field, TextInput, TextArea, SectionCard, ListAddBtn, ListRemoveBtn, NumberInput } from "./_shared";
import ImageUploadField from "./ImageUploadField";

export default function EditTestimonials({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setItem = (i, key, v) => {
    const items = [...(value.items || [])];
    items[i] = { ...items[i], [key]: v };
    set("items", items);
  };
  const addItem = () => set("items", [...(value.items || []), { name: "", text: "", rating: 5, image: "" }]);
  const removeItem = (i) => set("items", (value.items || []).filter((_, idx) => idx !== i));

  return (
    <SectionCard title="Depoimentos">
      <div className="space-y-5">
        <Field label="Overline"><TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="testimonials-overline-input" /></Field>
        <Field label="Título"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="testimonials-title-input" /></Field>
        <Field label="Subtítulo"><TextArea value={value.subtitle} onChange={(v) => set("subtitle", v)} rows={2} testId="testimonials-subtitle-input" /></Field>

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs tracking-[0.2em] uppercase text-onyx/60">Depoimentos</span>
            <ListAddBtn onClick={addItem} label="Adicionar depoimento" testId="testimonials-add-item" />
          </div>
          <div className="space-y-4">
            {(value.items || []).map((t, i) => (
              <div key={i} data-testid={`testimonial-row-${i}`} className="border border-border p-4 space-y-3">
                <div className="grid sm:grid-cols-2 gap-3">
                  <Field label="Nome"><TextInput value={t.name} onChange={(v) => setItem(i, "name", v)} testId={`testimonial-name-${i}`} /></Field>
                  <Field label="Avaliação (1-5)"><NumberInput value={t.rating} onChange={(v) => setItem(i, "rating", v)} testId={`testimonial-rating-${i}`} /></Field>
                </div>
                <Field label="Texto"><TextArea value={t.text} onChange={(v) => setItem(i, "text", v)} rows={3} testId={`testimonial-text-${i}`} /></Field>
                <ImageUploadField label="Foto (avatar)" value={t.image} onChange={(v) => setItem(i, "image", v)} testId={`testimonial-image-${i}`} />
                <div className="flex justify-end"><ListRemoveBtn onClick={() => removeItem(i)} testId={`testimonial-remove-${i}`} /></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SectionCard>
  );
}
